import { render } from "./HospitalSelector.vue?vue&type=template&id=aed33ab0&scoped=true"
import script from "./HospitalSelector.vue?vue&type=script&lang=js"
export * from "./HospitalSelector.vue?vue&type=script&lang=js"

import "./HospitalSelector.vue?vue&type=style&index=0&id=aed33ab0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aed33ab0"]])

export default __exports__